import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import TextCardBase from "../../bases/TextCardBase";
import { Rank } from "../../../../../core/types";
import Image from "../../../../../elements/Image";

var PairedHorizontalCard = function PairedHorizontalCard(_ref) {
  var borderless = _ref.borderless,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      footer = _ref.footer,
      imgAnchor = _ref.imgAnchor,
      imgSrc = _ref.imgSrc,
      imgSrcSet = _ref.imgSrcSet,
      heading = _ref.heading,
      headingRank = _ref.headingRank,
      href = _ref.href,
      id = _ref.id;
  var getClassName = getClassNameFactory(PairedHorizontalCard.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: borderless ? "borderless" : ""
    })
  }, /*#__PURE__*/React.createElement(TextCardBase, {
    anchor: "top",
    borderless: true,
    description: description,
    eyebrow: eyebrow,
    footer: footer,
    heading: heading,
    headingRank: headingRank,
    href: href,
    size: "small",
    id: id,
    renderContent: function renderContent(content) {
      return /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "content"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "image"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "imageInner"
        })
      }, /*#__PURE__*/React.createElement(Image, {
        alt: "",
        anchor: imgAnchor,
        fit: "cover",
        sizes: Image.sizes.oneThird,
        src: imgSrc,
        srcSet: imgSrcSet
      }))), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "contentInner"
        })
      }, content));
    }
  }));
};

PairedHorizontalCard.displayName = "PairedHorizontalCard";
/* eslint-disable max-len */

PairedHorizontalCard.propTypes = {
  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Description text
   */
  description: PropTypes.node,

  /**
   * Eyebrow text
   */
  eyebrow: PropTypes.string.isRequired,

  /**
   * Footer. Should be a valid card footer, like ArticleCardFooter.
   */
  footer: PropTypes.node.isRequired,

  /**
   * Heading text
   */
  heading: PropTypes.string.isRequired,

  /**
   * Heading rank. 1 will render `<h1 />`, and so on. Defaults to 3.
   */
  headingRank: PropTypes.oneOf(Object.values(Rank)),

  /**
   * Card URL
   */
  href: PropTypes.string.isRequired,

  /**
   * Anchor point for the image.
   */
  imgAnchor: PropTypes.oneOf(Object.values(Image.AnchorTypes)),

  /**
   * Image `src`. Used if srcSet is not defined, or as a fallback.
   */
  imgSrc: PropTypes.string.isRequired,

  /**
   * A comma-separated list indicating a set of possible image sources for the image. The image will be fit to cover. This is used by the user agent to determine the correct image for different screen sizes. Same format as [srcSet](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#Example_4_Using_the_srcset_and_sizes_attributes), i.e. `my-image-200.png 200w, my-image-200.png 200w`.
   */
  imgSrcSet: PropTypes.string,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
};
/* eslint-enable max-len */

PairedHorizontalCard.defaultProps = {
  headingRank: "3",
  imgGradient: false,
  imgAnchor: "C"
};
export default PairedHorizontalCard;